// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Qnc2","resendInfoText":"OnGoingPaymentBox_resendInfoText__1B-g8"};